import { render, staticRenderFns } from "./UserWall.vue?vue&type=template&id=fa076036&"
import script from "./UserWall.vue?vue&type=script&lang=ts&"
export * from "./UserWall.vue?vue&type=script&lang=ts&"
import style0 from "./UserWall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports